import { createAPIInstance } from './api'

export function fetchSponsersList(query) {
  return createAPIInstance().get(`sponsor/get_details`)
}
